/* unplugin-vue-components disabled */import script from "./FooterView2.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterView2.vue?vue&type=script&setup=true&lang=js"

import "./FooterView2.vue?vue&type=style&index=0&id=7b7078ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b7078ca"]])

export default __exports__